<app-scoreboard [remainingMines]="mineCount - flagCount" [totalMines]="mineCount" [gameState]="gameOver ? 'lost' : gameWon ? 'won' : ''" (resetGame)="resetGame()"></app-scoreboard>
<!-- <p *ngIf="rCell" class="debug">Reveal Cell {{ tRow }}, {{ tCol }}</p>
<p *ngIf="tFlag" class="debug">Toggle Flag {{ tRow }}, {{ tCol }}</p>
<p *ngIf="!rCell" class="debug">...</p>
<p *ngIf="!tFlag" class="debug">...</p> -->
<div class="grid">
  <div
    *ngFor="let row of grid; let rowIndex = index"
    class="grid-row"
  >
    <div
      *ngFor="let cell of row; let colIndex = index"
      class="grid-cell"
      [ngClass]="{
        revealed: cell.revealed,
        flagged: cell.flagged,
        mine: cell.mine
      }"
      (click)="revealCell(rowIndex, colIndex)"
      (touchstart)="onTouchStart(rowIndex, colIndex)"
      (touchend)="onTouchEnd(rowIndex, colIndex)"
      (contextmenu)="toggleFlag(rowIndex, colIndex); $event.preventDefault()"
    >
      <span *ngIf="cell.revealed && !cell.mine" [ngStyle]="{color: getCellColor(cell.adjacentMines)}">
        {{ cell.adjacentMines > 0 ? cell.adjacentMines : '' }}
      </span>
      <!-- <span *ngIf="cell.flagged">🚩</span> -->
    </div>
  </div>
</div>